function RandomLogos_handler(container){
    _container = container;
    _nb_zones = 0;
    console.log("NEW LOGOS RANDOM CONTAINER : " + container);
    document.querySelectorAll("#" + _container + " .random-logos .logo-container").forEach(function(zone, i){
        if (getComputedStyle(zone).display != "none"){
            _nb_zones ++;
        }
    });
    _current_zone = -1;
    _nb_logos = document.querySelector("#" + _container + " .random-logos .logo-container").querySelectorAll("img").length;
    _current_logo = _nb_zones - 1;
    

    function change_logo(_this){
        if(_this._current_logo < _this._nb_logos -1 ){
            _this._current_logo ++;
        }else{
            _this._current_logo = 0;
        }
        if(_this._current_zone < _this._nb_zones - 1 ){
            _this._current_zone ++;
        }else{
            _this._current_zone = 0;
        }

        
      //  console.log("Change logo :  " + _this._container + " -> logo " + _this._current_logo + "dans zone " + _this._current_zone);

        document.querySelectorAll("#" + _this._container + " .random-logos .logo-container").forEach(function(zone, i){

            if(i == _this._current_zone){
                zone.querySelectorAll("img").forEach(function(logo, j){
                    if(j == _this._current_logo){
                        logo.classList.add("visible");
                    }else{
                        logo.classList.remove("visible");
                    }
                })
            }
        })
    }
   

    if(_nb_logos > _nb_zones){
        console.log("_________ ACTIVATE RANDOM LOGOS : " + _container + "________");
        var _this = {
            _container:_container,
            _current_logo:_current_logo,
            _nb_logos:_nb_logos,
            _current_zone:_current_zone,
            _nb_zones:_nb_zones
        }
        setInterval(function(){           
            change_logo(_this);
        }, 2000);
    }
}

var RandomLogos = {
    init: function (container) {
        if( document.querySelectorAll("#" + container + " .random-logos").length > 0 ){
            var _randomLogos_handler = new RandomLogos_handler(container);
        }
    }
};